import * as yup from 'yup'

const step0_schema = yup.object().shape({
  start_date: yup.date().required(),
  end_date: yup.date().nullable().when('over12Months', {
    is: 'under',
    then: yup.date().required(),
  }),
  no_guest: yup.number().required(),
})

const step1_schema = yup.object().shape({
  tenant_age: yup.number().required(),
  tenant_gender: yup.string().required(),
  tenant_reason: yup.string().required(),
  tenant_comment: yup.string().required(),
})

const step2_schema = yup.object().shape({
  tenant_proposal: yup.number().required(),
})

export const getNextStep = async (booking) => {
  let step = 0

  try {
    await step0_schema.validate(booking)
  } catch (error) {
    return step
  }
  step++

  try {
    await step1_schema.validate(booking)
  } catch (error) {
    return step
  }
  step++

  try {
    await step2_schema.validate(booking)
  } catch (error) {
    return step
  }

  return step
}
